export default __webpack_public_path__ + "static/media/WhitneySSm-Bold-Adv_Web.ca45e93e.woff2";